import { IVector } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IVectorPropertyEditable {
  vector(): IPropertyEditable<IVector>;
}

export function instanceOfIVectorPropertyEditable(instance: any): instance is IVectorPropertyEditable {
  return instance
      && instance.vector
      && instanceOfIPropertyEditable<IVector>(instance.vector());
}
